
const loading = {
  state: {
    btLoading:false  // 提交按钮状态
  },

  mutations: {
    SET_BTLOADING: (state, item) => {
      state.btLoading = item
    }
  },

  actions: {

  }
}

export default loading
